import {
  PriceTierContainerDiscountContainerUpdateRequestType,
  PriceTierContainerDiscountContainerUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceTierContainerDiscountUpdate = (
  priceTierContainerDiscountId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceTierContainerDiscountContainerUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `price-tier-container-discount/${priceTierContainerDiscountId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PriceTierContainerDiscountContainerUpdateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTierContainerDiscount],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.ProductAssignment],
      });
    },
  });
};
